import React from "react"
import { ConfigFormListItem } from "./config_form_list_item"
import styled from "styled-components"
import { colors } from "../../common/colors/app_colors"
import { appStrings } from "../../common/strings/app_strings"
import redDot from "../../images/red-dot.png"
const { aTagBlue } = colors

const { 
    connectAnother,
    disconnectCalendar,
    disconnectAccount,
    accountRemovedToastWarning,
    calendarRemovedToastWarning,
    noAccounts,
    connectAccount,
    noCalendars,
} = appStrings.connectedApps

export const ConfigFormList = ({
    listItems,
    currentUserId,
    handleStartGoogleOauth,
    removeAccount,
    removeCalendar,
    config,
    isAccount,
    title,
}) => {
    const isListFull = listItems.length > 0
    const connectString = isListFull ? connectAnother : connectAccount
    const nullStateString = isAccount ? noAccounts : noCalendars
    const removeAction = isAccount ? removeAccount : removeCalendar
    const warningText = isAccount ? accountRemovedToastWarning : calendarRemovedToastWarning
    return (
        <ConnectedAccountsWrapper>
            <h5>{title}</h5>
            {isListFull
                ? listItems.map(item => {
                    const { userId, userFullName, id, googleAccountEmail, gCalendarName } = item
                    const isCurrentUser = userId === currentUserId
                    const disconnectString = isCurrentUser && isAccount
                        ? disconnectAccount
                        : !isAccount ? disconnectCalendar : ""
                    const name = isAccount
                        ? `${googleAccountEmail} (${userFullName})`
                        : `${gCalendarName} (📅${googleAccountEmail})`
                    return (
                        <ConfigFormListItem
                            key={id}
                            name={name}
                            isCurrentUser={isCurrentUser}
                            disconnectString={disconnectString}
                            config={config}
                            item={item}
                            toastAction={removeAction}
                            toastText={warningText}
                        />
                    )
                })
                : <div className="null-state">
                    <img src={redDot} className="red-dot" alt="red dot" />
                    <span>{nullStateString}</span>
                </div>
            }
            {isAccount && (
                <span onClick={handleStartGoogleOauth} className="connect-another">{connectString}</span>
            )}
        </ConnectedAccountsWrapper>
    )
}

const ConnectedAccountsWrapper = styled.div`
    padding: 5px 0;
    .connect-another {
        cursor: pointer;
        color: ${aTagBlue};
        display: block;
        margin-top: 10px;
    }
    .red-dot {
        height: 17px;
        width: 17px;
        margin: auto 0px;
        display: inline-block;
        margin-right: 10px;
    }
    .null-state {
        display: flex;
        flex-direction: row;
        width: 100%;
    }
    @media (max-width: 425px) {
        .red-dot {
            height: 10px;
            width: auto;
        }
    }
`



// WEBPACK FOOTER //
// ./src/components/connected_apps/config_form_list.jsx